var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.690314 15.7501C-0.190579 16.631 -0.275034 18.3084 0.708299 19.2917C1.69163 20.275 3.369 20.1906 4.24989 19.3097C6.89255 16.667 3.33297 13.1075 0.690314 15.7501ZM2.43187 10.0165L2.44456 12.5222C5.2061 12.5354 7.46465 14.7939 7.47781 17.5554L9.98352 17.5681C9.96153 13.4183 6.58171 10.0385 2.43187 10.0165ZM2.38187 0L2.39368 2.50482C10.6792 2.54697 17.453 9.32084 17.4952 17.6063L20 17.6181C19.9508 7.93726 12.0627 0.049235 2.38187 0ZM14.9912 17.5937L12.4875 17.5808C12.4594 12.0577 7.94228 7.54062 2.41921 7.51252L2.40634 5.00878C9.32124 5.04395 14.956 10.6788 14.9912 17.5937Z",
    fill: "#5DA3E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.6456ac70b89224e839aea72c0c8fcfc6.svg";
export { ForwardRef as ReactComponent };